import React from "react";
import styles from './../Prices.module.scss';

interface NoPriceProps {
  names: string[];
}

const NoPrice: React.FC<NoPriceProps> = ({ names }) => {
  return (
    <div>
      {names.slice(0, 2).map((el) => (
        <div key={el} className={styles.container}>
        <span>
          {el}
          &nbsp;
        </span>
        <p className={styles.price_on_request}>
          Price on request
        </p>
      </div>
      ))}
    </div>
  )
}

export default NoPrice;